import React, { useState, useEffect, Profiler, useRef } from 'react'
import './Fe.css'
import c1 from '../image/c1.png'
import c2 from '../image/c2.png'
import c3 from '../image/c3.png'
import c4 from '../image/c4.png'
import c5 from '../image/c5.png'
import c6 from '../image/c6.png'
import SA1 from '../image/sa1.jpg'
import SA2 from '../image/sa2.jpg'
import SA3 from '../image/sa3.png'
import LC1 from '../image/leadgen-collage-1.jpg'
import LC2 from '../image/leadgen-collage-2.jpg'
import LC3 from '../image/leadgen-collage-3.png'
import LC4 from '../image/leadgen-collage-4.png'
import LC5 from '../image/leadgen-collage-5.png'
import LC6 from '../image/leadgen-collage-6.png'
import LC7 from '../image/leadgen-collage-7.jpg'
import logo from '../image/logo.png'
import businessProfessionals2 from '../image/businessProfessionals-2.jpg'
import F1 from '../image/features-1.jpg'
import F2 from '../image/features-2.jpg'
import F3 from '../image/features-3.jpg'
import F4 from '../image/features-4.jpg'
import F5 from '../image/features-5.jpg'
import F6 from '../image/features-6.jpg'
import comparisonBad from '../image/comparison-1.jpg'
import comparisonGood from '../image/comparison-2.jpg'
import know1 from '../image/now-i-know-1.jpg'
import know2 from '../image/now-i-know-2.jpg'
import know3 from '../image/now-i-know-3.jpg'
import know4 from '../image/now-i-know-4.jpg'
import know5 from '../image/now-i-know-5.jpg'
import know6 from '../image/now-i-know-6.jpg'
import imagine1 from '../image/imagine-1.png'
import commercial1 from '../image/commercial-1.jpg'
import awesome1 from '../image/awesome-1.jpg'
import awesome2 from '../image/awesome-2.jpg'
import awesome3 from '../image/awesome-3.jpg'
import awesome4 from '../image/awesome-4.jpg'
import awesome5 from '../image/awesome-5.jpg'
import awesome6 from '../image/awesome-6.jpg'
// import LC7 from '../image/leadgen-collage-7.png'
import AccessAnywhere1 from '../image/access-anywhere-1.jpg'
import AccessAnywhere2 from '../image/access-anywhere-2.jpg'
import AccessAnywhere3 from '../image/access-anywhere-3.jpg'
import AccessAnywhere4 from '../image/access-anywhere-4.jpg'
import guarantee1 from '../image/guarantee-1.png'
import TrafficAudience1 from '../image/traffic-audience-1.png'
import TrafficAudience2 from '../image/traffic-audience-2.png'
import TrafficAudience3 from '../image/traffic-audience-3.png'
import TrafficAudience4 from '../image/traffic-audience-4.png'
import TrafficAudience5 from '../image/traffic-audience-5.png'
import TrafficAudience6 from '../image/traffic-audience-6.png'
import TrafficAudience7 from '../image/traffic-audience-7.png'
import TrafficAudience8 from '../image/traffic-audience-8.png'
import bizMachine1 from '../image/biz-machine-1.jpg'
import bizMachine2 from '../image/biz-machine-2.jpg'
import bizMachine3 from '../image/biz-machine-3.jpg'
import bizMachine4 from '../image/biz-machine-4.jpg'
import ResearchDiscovery2 from '../image/research-discovery2.jpg'
import bonus1 from '../image/bonus-1.png'
import bonus2 from '../image/bonus-2.png'
import bonus3 from '../image/bonus-3.png'
import bonus4 from '../image/bonus-4.png'
import mailsuite1 from '../image/mail-suite-1.jpg'
import mailsuite2 from '../image/mail-suite-2.jpg'
import mailsuite3 from '../image/mail-suite-3.jpg'
import mailsuite4 from '../image/mail-suite-4.jpg'
import Profile from '../image/profile-1.jpg'
import feVideoPoster from '../image/fe-video-poster.png'
import fedemovideo from '../image/fe-demo.mp4'
import addtocart from '../image/add-to-cart.png'
import demothumbnail from '../image/demo-thumbnail.png'
import fesalesvideo from '../image/fe-sale.mp4'

const TYPING_TOOLS = [
  'Apollo',
  'ZoomInfo',
  'Hunter ',
  'Mailchimp',
  'CRM Tools',
]

const OFFER_FEATURES = [
  {
    title: 'Find targeted leads by industry, location & niche',
    desc: 'Find companies using filters such as industry, country, and city.',
  },
  {
    title: 'Discover real business contacts ready for outreach',
    desc: 'Explore publicly available company profiles for research and outreach preparation.',
  },
  {
    title: 'Save leads into smart lists & organize with tags (Hot, Follow-up, etc.)',
    desc: 'Narrow down companies by industry category, business type, and location.',
  },
  {
    title: 'Built-in outreach system: send messages & schedule follow-ups',
    desc: 'View and manage company information from one organized dashboard.',
  },
  {
    title: 'Track responses: Interested • Not Interested • No Answer',
    desc: 'Access business details such as company name, industry, and listed contact information.',
  },
  {
    title: 'AI-powered message generator for faster outreach',
    desc: 'Download company research data in CSV format for your records or internal use.',
  },
  {
    title: 'Central dashboard to manage leads, lists & daily activities',
    desc: 'Ideal for agencies, consultants, freelancers, and B2B service providers.',
  },
  {
    title: 'Export clean data (CSV, Google Sheets, CRM-ready)',
    desc: 'Simple and clean dashboard with no technical skills required.',
  },
  {
    title: 'Multi-user access with team roles & shared lists',
    desc: 'Access your research data anytime from any device.',
  },
  {
    title: 'See Your Pipeline Clearly — Know Which Leads Need Follow-Up',
    desc: 'Helps reduce manual company research and tool switching.',
  },
  {
    title: 'Beginner-Friendly: Just Search → Save → Contact → Close',
    desc: 'Suitable for researching businesses across various markets and niches.',
  },
  {
    title: '100% cloud-based — access anytime, anywhere',
    desc: 'Designed to support responsible use of publicly available business data.',
  },
]

const WHY_CHOOSE_ITEMS = [
  {
    title: 'Fast, Cloud-Based Lead System With Real-Time Data',
    sub: 'Fast, stable, and built to handle your daily lead generation and outreach workflow',
  },
  {
    title: 'Compliance-Friendly Data & Outreach',
    sub: 'Work with publicly available business data — designed to stay within platform guidelines',
  },
  {
    title: 'Built-In Outreach, Follow-Ups & Pipeline Tracking',
    sub: 'Send messages, schedule follow-ups, and track responses — all in one place',
  },
  {
    title: 'Smart Targeting + AI Message Generator',
    sub: 'Find the right leads faster and generate outreach messages with AI support',
  },
]


const TRAFFIC_SOURCE_CARDS = [
  {
    title: 'Built-In Outreach & Follow-Up System',
    alt: 'Professional reviewing analytics and compliance data on a laptop',
    src: c1,
    playOverlay: false,
  },
  {
    title: 'YouTube Lead Discovery & Outreach',
    alt: 'Creator with microphone recording video content',
    src: c2,

    playOverlay: false,
  },
  {
    title: 'Facebook & LinkedIn Lead Mining',
    alt: 'Business professionals collaborating with social network context',
    src: c3,
    playOverlay: false,
  },
  {
    title: 'Instagram Outreach & DM Prospecting',
    alt: 'Person using a smartphone with social media and messaging',
    src: c4,
    playOverlay: false,
  },
  {
    title: 'Website & SEO-Based Lead Discovery',
    alt: 'Person working on a laptop focused on content and SEO',
    src: c5,
    playOverlay: false,
  },
  {
    title: 'TikTok Business Prospecting',
    alt: 'Creative professional presenting short-form video content',
    src: c6,
    playOverlay: false,
  },
]

const FE_PAYMENT_PLANS = [
  {
    badge: 'Most Popular',
    badgeTone: 'blue',
    name: 'STARTER (FE)',
    // desc: 'Ideal for solo operators who want lead search, lists & basic outreach in one place.',
    price: '$8.99',
    cta: 'Start with Starter',
    ctaHref: '/2.0fe',
    features: [
      { ok: true, text: 'Find targeted leads (any niche, location, industry)' },
      { ok: true, text: 'Access real business profiles & basic contact data' },
      { ok: true, text: 'Save leads into smart lists' },
      { ok: true, text: 'Tag & organize leads (Hot, Contacted, Follow-up)' },
      { ok: true, text: 'Basic pipeline tracking (New → Contacted)' },
      { ok: true, text: 'Beginner-friendly dashboard' },
      // { ok: false, text: 'No AI outreach system' },
      // { ok: false, text: 'No follow-up automation' },
      // { ok: false, text: 'No exports / CRM sync' },
    ],
  },
  {
    badge: 'Best Value',
    badgeTone: 'purple',
    name: 'Pro Lead Suite',
    // desc: 'For marketers who need faster workflows, AI messaging & stronger list growth.',
    price: '$20',
    cta: 'Go Pro Now',
    ctaHref: '/2.0oto1',
    features: [
      { ok: true, text: 'Everything in Starter' },
      { ok: true, text: 'AI-powered outreach message generator' },
      { ok: true, text: 'Send outreach messages directly' },
      { ok: true, text: 'Schedule automated follow-ups' },
      { ok: true, text: 'Track responses (Interested / No Reply / Not Interested)' },
      { ok: true, text: 'Save & reuse message templates' },
      { ok: true, text: 'Better limits for outreach & daily usage' },
      // { ok: false, text: 'No advanced export / CRM tools' },
      // { ok: false, text: 'No team collaboration' },
    ],
  },
  {
    badge: 'Premium',
    badgeTone: 'green',
    name: 'AGENCY EDITION (OTO2)',
    // desc: 'Built for agencies managing multiple clients, lists & outreach from one dashboard.',
    price: '$59',
    cta: 'Get Agency Access',
    ctaHref: '/2.0oto2',
    features: [
      { ok: true, text: 'Everything in Pro' },
      { ok: true, text: 'Export leads (CSV, Google Sheets, CRM-ready)' },
      { ok: true, text: 'Advanced lead management & segmentation' },
      { ok: true, text: 'Full pipeline tracking (New → Contacted → Closed)' },
      { ok: true, text: 'Activity tracking & lead history' },
      { ok: true, text: 'Multi-user access (team roles)' },
      { ok: true, text: 'Shared lists & team collaboration' },
      { ok: true, text: 'Central dashboard for leads + outreach + activity' },
    ],
  },
  {
    badge: 'Scale',
    badgeTone: 'teal',
    name: 'UNLIMITED EDITION (OTO3)',
    // desc: 'Maximum capacity for power users & teams who live inside their outreach stack.',
    price: '$98',
    cta: 'Get Unlimited Now',
    ctaHref: '/2.0oto3',
    features: [
      { ok: true, text: 'Everything in Agency' },
      { ok: true, text: 'Unlimited lead searches & usage' },
      { ok: true, text: 'Unlimited outreach & follow-ups' },
      { ok: true, text: 'Unlimited exports & data access' },
      { ok: true, text: 'No usage restrictions (full system unlocked)' },
      { ok: true, text: 'Best for agencies & high-volume users' },
      { ok: true, text: 'Commercial use (client work ready)' },
      { ok: true, text: 'Priority performance & scaling support' },
    ],
  },
]

const COMMERCIAL_LICENSE_BULLETS = [
  'Find and manage leads for your own business or client projects',
  'Set follow-ups and track responses from one dashboard ',
  'Manage multiple clients using smart lists, tags & pipeline system ',
  'Offer lead generation, outreach, or appointment-setting services ',
  'Export or deliver leads to clients (CSV, Google Sheets, CRM-ready) ',
  'Track performance, activity & results across campaigns ',
  'Create and run outreach campaigns using AI-generated messages ',
]

const AWESOME_FEATURES_CARDS = [
  {
    title: 'Dedicated Support When You Need It',
    caption: 'Get quick help, guidance, and answers whenever you get stuck',
    alt: 'Support specialist with headset giving a thumbs up',
    src: awesome1,
  },
  {
    title: 'No Technical Skills Required',
    caption: 'Simple dashboard built for beginners, freelancers & non-tech users',
    alt: 'Person at a desk with laptop looking unsure or overwhelmed',
    src: awesome2,
  },
  {
    title: 'Step-By-Step Training Included',
    caption: 'Learn how to find leads, send outreach, and manage your workflow step-by-step',
    alt: 'Presenter with whiteboard and camera on tripod',
    src: awesome3,
  },
  {
    title: 'Simple & Easy-To-Use Dashboard',
    caption: 'Clean interface to manage leads, outreach, follow-ups & tracking in one place',
    alt: 'Team collaborating with laptops in a bright office',
    src: awesome4,
  },
  {
    title: 'One-Time Access — No Monthly Fees',
    caption: 'Pay once and use the complete system without recurring costs',
    alt: 'Laptop on a desk with calendar and notes',
    src: awesome5,
  },
  {
    title: 'Ongoing Improvements & Updates',
    caption: 'Regular updates, new features & improvements added over time',
    alt: 'Hands typing on a keyboard with technology workflow',
    src: awesome6,
  },
]

const TRAFFIC_AUDIENCE_CARDS = [
  {
    label: 'Coaches & Consultants',
    title: 'Find high-quality prospects & book more calls consistently',
    alt: 'Professional coach in business attire',
    src: TrafficAudience1,
  },
  {
    label: 'Agencies & Freelancers',
    title: 'Manage client leads, outreach & follow-ups from one dashboard',
    alt: 'Marketing professional presenting ideas',
    src: TrafficAudience2,
  },
  {
    label: 'B2B Service Providers',
    title: 'Generate targeted leads & close more business opportunities',
    alt: 'Freelancer working on a laptop at a desk',
    src: TrafficAudience3,
  },
  {
    label: 'Entrepreneurs & Startups',
    title: 'Build a steady pipeline of leads without expensive tools',
    alt: 'Confident entrepreneur in a suit',
    src: TrafficAudience4,
  },
  {
    label: 'Content & Course Creators',
    title: 'Find potential buyers & grow your audience faster',
    alt: 'Creator with camera and creative setup',
    src: TrafficAudience5,
  },
  {
    label: 'eCommerce & Local Businesses',
    title: 'Reach local customers & generate more sales opportunities',
    alt: 'Instructor presenting on a screen',
    src: TrafficAudience6,
  },
  {
    label: 'Digital Marketers',
    title: 'Run lead gen & outreach campaigns more efficient',
    alt: 'Digital globe representing global publishing and networks',
    src: TrafficAudience7,
  },
  {
    label: 'Affiliate Marketers',
    title: 'Find targeted prospects & promote offers with better conversions',
    alt: 'Shopping and online retail lifestyle',
    src: TrafficAudience8,
  },

]

const WINNING_SIDE_LINES = [
  'One Dashboard To Find, Manage, Contact & Track Leads',
  'AI-Powered Outreach + Automated Follow-Ups',
  'Smart Lists, Tags & Lead Status Tracking',
  'Never Miss A Follow-Up Or Opportunity',
  'Manage Leads, Conversations & Pipeline In One Place',
  'Built For Daily Use — Simple To Start, Powerful To Scale',
]

const LOSING_SIDE_LINES = [
  'Switching Between Tools For Leads, Emails, CRM & Tracking',
  'No Clear System To Manage Or Track Leads Properly',
  'Manual Work, Messy Data & Confusing Workflows',
  'Missed Follow-Ups = Lost Clients & Revenue',
  'Wasting Hours On Tasks That Should Be Automated',
  'Inconsistent Leads, Conversations & Results',
]

const WORKFLOW_BEFORE_LINES = [
  'No clear system to manage leads from start to finish',
  'Leads, messages & notes scattered everywhere',
  'Missed follow-ups = lost clients and opportunities',
  'Slow, manual workflows that feel overwhelming',
]

const WORKFLOW_AFTER_LINES = [
  'Organized smart lists, tags & lead status tracking',
  'AI-powered outreach with structured follow-ups',
  'Clear pipeline visibility from New → Contacted → Closed',
  'Better consistency, faster action, and easier scaling',
  'One clean workflow to find, manage, and convert leads daily'
]

const BUSINESS_MACHINE_CARDS = [
  {
    title: 'Build Your Daily Lead Pipeline',
    desc: 'Find targeted leads in seconds and save them into smart lists for consistent daily outreach',
    src: bizMachine1,
    alt: 'Laptop on a desk showing a dashboard with floating app icons',
    glow: false,
  },
  {
    title: 'Run Outreach Campaigns',
    desc: 'Generate AI-powered messages, send outreach, and schedule follow-ups from one place',
    src: bizMachine2,
    alt: 'Professional working at a wide curved monitor with video editing software',
    glow: false,
  },
  {
    title: 'Manage Leads In One Place',
    desc: 'Organize leads with tags, track status (New → Contacted → Closed), and manage everything easily',
    src: bizMachine3,
    alt: 'Designer at a desk with monitor showing website and funnel layouts',
    glow: false,
  },
  {
    title: 'Stay Consistent & Organized',
    desc: 'Track progress, follow up on time, and avoid missed opportunities',
    src: bizMachine4,
    alt: 'Professional at a desk with chat and automation interface on screen',
    glow: false,
  },
]

const ACCESS_ANYWHERE_IMAGES = [
  {
    alt: 'Man working remotely on a beach with laptop',
    src: AccessAnywhere1,
  },
  {
    alt: 'Family walking at the beach during sunset',
    src: AccessAnywhere2,
  },
  {
    alt: 'Parents and children together in a living room',
    src: AccessAnywhere3,
  },
  {
    alt: 'Friends celebrating together at a colorful party',
    src: AccessAnywhere4,
  },
]

const FE_PRICING_FEATURES = [
  'Find targeted leads in seconds (any niche, location, industry)',
  'Save leads into smart lists & organize with tags (Hot, Contacted, Follow-up)',
  'Generate AI-powered outreach messages instantly',
  'Send outreach & schedule follow-ups from one dashboard',
  'Track responses & manage lead status (New → Contacted → Closed)',
  'Manage your entire lead pipeline in one place',
  'Export or sync leads (CSV, Google Sheets, CRM-ready)',
  'Use for your own business or client projects (Commercial Use Included)',

]

const HOW_IT_WORKS_STEPS = [
  {
    n: 1,
    title: 'Access Your Dashboard',
    desc: 'Log in to your complete lead system — manage leads, outreach, and pipeline from one place',
    icon: 'login',
  },
  {
    n: 2,
    title: 'Find Targeted Leads',
    desc: 'Use smart filters to discover high-quality leads by niche, location, and category',
    icon: 'filters',
  },
  {
    n: 3,
    title: 'Save, Tag & Manage Leads',
    desc: 'Organize leads into smart lists, add tags (Hot, Contacted, Follow-up), and track activity',
    icon: 'data',
  },
  {
    n: 4,
    title: 'Reach Out, Track & Close Deals',
    desc: 'Send AI-powered outreach, schedule follow-ups, track responses, and move leads through your pipeline',
    icon: 'export',
  },
]

function FeHiwIcon({ name }) {
  const common = { width: 40, height: 40, viewBox: '0 0 40 40', 'aria-hidden': true }
  switch (name) {
    case 'login':
      return (
        <svg {...common}>
          <rect x="8" y="10" width="16" height="22" rx="2" fill="none" stroke="#1565c0" strokeWidth="2" />
          <path
            d="M24 21h10M29 17l4 4-4 4"
            fill="none"
            stroke="#1565c0"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="16" cy="24" r="3" fill="#1565c0" />
        </svg>
      )
    case 'filters':
      return (
        <svg {...common}>
          <ellipse cx="20" cy="20" rx="14" ry="10" fill="none" stroke="#0f172a" strokeWidth="2" />
          <circle cx="20" cy="20" r="4" fill="#0f172a" />
        </svg>
      )
    case 'data':
      return (
        <svg {...common}>
          <rect x="8" y="8" width="24" height="26" rx="2" fill="none" stroke="#37474f" strokeWidth="2" />
          <circle cx="20" cy="16" r="4" fill="#37474f" />
          <path d="M12 26h16M14 30h12" stroke="#37474f" strokeWidth="2" strokeLinecap="round" />
          <path
            d="M28 10l3 3-6 6"
            fill="none"
            stroke="#ff9800"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      )
    case 'export':
      return (
        <svg {...common}>
          <rect x="6" y="10" width="28" height="20" rx="2" fill="none" stroke="#1565c0" strokeWidth="2" />
          <path d="M10 16h20M10 22h12" stroke="#1565c0" strokeWidth="2" strokeLinecap="round" />
          <rect x="14" y="24" width="12" height="8" rx="1" fill="#4caf50" opacity="0.35" />
          <path d="M16 28h8M20 26v4" stroke="#2e7d32" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      )
    default:
      return null
  }
}

const WORKFLOW_FEATURES = [
  { key: 'bolt', label: 'Instant Lead Discovery' },
  { key: 'target', label: 'Smart Targeting & Filtering' },
  { key: 'building', label: 'Lead Management & Organization' },
  { key: 'team', label: 'Team Workflow & Collaboration' },
]

const WORKFLOW_STATS = [
  { value: 'Save Hours Every Week', label: 'Of Manual Prospecting Every Week' },
  { value: 'One Dashboard', label: 'Dashboard For Leads, Outreach & Follow-Ups' },
  { value: 'No Monthly Fees', label: 'Fees — One-Time Access' },
  { value: 'Built Using Public Data', label: 'Public Business Data (Compliance-Friendly)' },
]



const LEADGEN_BULLETS = [
  'Find Targeted Leads Instantly (Any Niche, Location, Industry)',
  'Save Leads Into Smart Lists & Organize With Tags (Hot, Follow-Up, Contacted)',
  'Generate AI-Powered Outreach Messages & Save Templates',
  'Automate Follow-Ups & Track Responses (Interested / No Reply / Closed)',
  'Manage Your Pipeline With Status Tracking (New → Contacted → Closed)',
  'Export Clean Data To CSV, Google Sheets & CRM (HubSpot / Zoho Ready)',
  'Collaborate With Team Members Using Shared Lists & Activity Logs',
  'Track Performance With Built-In Analytics (Leads, Messages, Exports)',
  'Control Usage With Built-In Limits & Upgrade System',
  'Manage Everything From One Central Dashboard)',
]

const LEADGEN_COLLAGE = [
  {
    src: LC1,
    alt: 'Business professional using a laptop',
    bubble: 'Discover High-Quality Business Leads',
    layout: 'tl',
  },
  {
    src: LC2,
    alt: 'Support specialist with headset',
    bubble: 'Turn Leads Into Organized & Actionable Data',
    layout: 'tr',
  },
  {
    src: LC3,
    alt: 'Professional reviewing a dashboard on laptop',
    bubble: 'Convert Conversations Into Paying Clients',
    layout: 'bc',
  },
]

const MAIL_SUITE_BULLETS = [
  'Generate AI Outreach Messages Instantly (Cold, Warm, Follow-Up)',
  'Save & Reuse Message Templates For Faster Outreach',
  'Schedule Smart Follow-Ups & Get “Due Today” Reminders',
  'Track Lead Status (New / Contacted / Interested / No Reply / Closed)',
  'Manage Conversations & Activity History In One Place',
  'Update Pipeline & Move Leads Through Stages Easily',
  'Organize Leads With Tags (Hot, Follow-Up, Priority)',
  'No Tool Switching — Everything Inside One Dashboard',
]

const MAIL_SUITE_COMPETITORS = [
  { name: 'Apollo' },
  { name: 'Instantly' },
  { name: 'Smartlead' },
  { name: 'Multiple Chrome Tools' },
]

const RESEARCH_DISCOVERY_POINTS = [
  'Find Targeted Leads Using AI Search (Any Niche, Location, Keywords)',
  'Extract Verified Business Data (Email, Company, Contact Details)',
  'Save Leads Into Smart Lists & Organize With Tags',
  'Track “Last Contacted” & Lead Activity History',
  'Instantly Prepare Leads For Outreach Campaigns',
  'Export Clean Data To CSV, Google Sheets & CRM Tools',
  'Manage & Segment Leads For Better Targeting',
  'Works For Agencies, Freelancers, Teams & B2B Businesses',
]

const FEATURES_NO_MORE = [
  {
    src: F1,
    alt: 'Professional reviewing email and contact data on a laptop',
    title: 'No Monthly Tool Chaos',
    caption: 'Pay once and get your complete lead generation + outreach system — no recurring tools needed',
  },
  {
    src: F2,
    alt: 'Smiling professional working on a laptop',
    title: 'Beginner-Friendly AI Dashboard',
    caption: 'Find, organize, and contact leads easily — even if you are non-technical',
  },
  {
    src: F3,
    alt: 'Working on a laptop with dashboards and tools',
    title: 'Everything In One Place',
    caption: 'Leads, smart lists, outreach, follow-ups, pipeline, and tracking — all inside one dashboard',
  },
  {
    src: F4,
    alt: 'Professional working independently on a laptop',
    title: 'Built For Solo Users & Teams',
    caption: 'Manage leads, share lists, and track team activity easily',
  },
  {
    src: F5,
    alt: 'Laptop showing analytics charts and email',
    title: 'AI-Powered Outreach System',
    caption: 'Generate high-converting messages, save templates, and send outreach faster',
  },
  {
    src: F6,
    alt: 'Hands typing on a laptop keyboard',
    title: 'Start In Minutes — No Setup Needed',
    caption: 'Log in, find leads, organize them, and start outreach instantly',
  },
]

const COMPARISON_BAD_POINTS = [
  'Manually search for leads across Google & directories',
  'Copy-paste data into spreadsheets (slow & error-prone)',
  'Use multiple tools for scraping, emails, CRM & outreach',
  'No system to organize leads, track status, or follow-ups',
  'Forget follow-ups & lose potential clients daily',
  'No visibility on what’s working or who to contact next',
]

const COMPARISON_GOOD_POINTS = [
  'Find targeted leads instantly using AI search (any niche, location)',
  'Save leads into smart lists & organize with tags (Hot, Follow-Up, Contacted)',
  'Generate AI-powered outreach messages & save templates',
  'Schedule follow-ups & track “Due Today” reminders',
  'Manage pipeline with status tracking (New → Contacted → Closed)',
  'Track responses (Interested / No Reply / Not Interested)',
  'Export clean data to CSV, Google Sheets & CRM tools',
  'Collaborate with team members using shared lists & activity logs',
  'Control everything from one simple dashboard',
]

// const COMPARISON_IMG_BAD =
//   'https://images.unsplash.com/photo-1544717305-2782549b5136?auto=format&fit=crop&w=640&q=80'

// const COMPARISON_IMG_GOOD =
//   'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=640&q=80'

const BONUSES = [
  {
    badge: 'BONUS 1',
    boxImg:
      bonus1,
    boxImgAlt: 'Notebook and documents representing sales templates',
    title: 'AI Outreach & High-Converting Message Templates',
    body: [
      'Ready-to-use outreach templates (cold, follow-up, closing)',
      'AI-optimized message scripts that get replies',
      'Proven frameworks to convert leads into clients',
      'Templates for agencies, freelancers & service providers',
      'Copy-paste & start outreach instantly',
    ],
  },
  {
    badge: 'BONUS 2',
    boxImg:
      bonus2,
    boxImgAlt: 'Coins and plant sprout symbolizing growing revenue from leads',
    title: 'Lead Monetization & Client Acquisition Blueprint',
    body: [
      'Step-by-step system to turn leads into paying clients',
      'How to close deals using outreach (no sales experience needed)',
      'Pricing strategies for services, agencies & freelancers',
      'Local + global lead monetization methods',
      'Avoid common mistakes that kill conversions',
    ],
  },
  {
    badge: 'BONUS 3',
    boxImg:
      bonus3,
    boxImgAlt: 'Team in a meeting discussing a client pitch',
    title: 'Done-For-You Client Closing Scripts',
    body: [
      'Complete pitch scripts to close clients from your leads',
      'Discovery call scripts + objection handling responses',
      'High-converting closing lines that seal deals',
      'Perfect for agencies, freelancers & consultants',
      'Turn conversations into paying clients',
    ],
  },
  {
    badge: 'BONUS 4',
    boxImg:
      bonus4,
    boxImgAlt: 'Laptop on a desk for digital affiliate marketing work',
    title: 'Affiliate & Recurring Income Blueprint',
    body: [
      'Find profitable affiliate offers & promote smarter',
      'Generate targeted leads using leadszora data',
      'Use outreach + content to drive consistent commissions',
      'Build long-term recurring income streams',
      'Scale affiliate earnings using automation',

    ],
  },
]

const NOW_I_KNOW_CARDS = [
  {
    src: know1,
    alt: 'Professional reviewing marketing dashboards on a laptop',
    title: 'Too Many Tools, No Real Workflow',
    text:
      'Switching between tools for leads, emails, CRM, and follow-ups — wasting time daily',
  },
  {
    src: know2,
    alt: 'Team collaborating with laptops',
    title: 'No Clear System To Manage Leads',
    text:
      'You have tools… but no structured system to organize, contact, and track leads',
  },
  {
    src: know3,
    alt: 'Secure digital workspace on a laptop',
    title: 'Rising Monthly Costs, No Real Results',
    text:
      'Paying for multiple tools every month — but still no complete system',
  },
  {
    src: know4,
    alt: 'Reviewing performance insights on a laptop',
    title: 'Scattered Leads & Data Everywhere',
    text:
      'Leads, messages, and follow-ups are unorganized and hard to track',
  },
  {
    src: know5,
    alt: 'Professional reviewing visual assets on a monitor',
    title: 'No Follow-Up System = Lost Clients',
    text:
      'You forget follow-ups and lose potential clients daily',
  },
  {
    src: know6,
    alt: 'Managing email and tasks on a laptop',
    title: 'Overwhelmed & Inconsistent Workflow',
    text:
      'Without a system, staying consistent with outreach becomes almost impossible',
  },
]

const LEAD_GEN_SIMPLE_FEATURES = [
  { emoji: '📍', label: 'Find Targeted Leads Instantly (any niche, location, industry) ' },
  { emoji: '🌐', label: 'Access Verified Business Data (real company profiles ready for outreach)' },
  { emoji: '✉️', label: 'Save Leads Into Smart Lists (create multiple lists + organize easily) ' },
  { emoji: '🎯', label: 'Tag & Track Lead Activity (Hot, Contacted, Follow-up + last contacted) ' },
  { emoji: '🌍', label: 'Send AI-Powered Outreach Messages (generate + send messages in seconds) ' },
  { emoji: '📍', label: 'Set Follow-Ups & Track Responses (never miss a lead again) ' },
  { emoji: '🌐', label: 'Manage Pipeline & Lead Status (New → Contacted → Interested → Closed) ' },
  { emoji: '✉️', label: 'Export or Sync Leads Easily (CSV, Google Sheets, CRM-ready) ' },
  { emoji: '🎯', label: 'Team Access & Shared Workflows (collaborate with your team) ' },
  { emoji: '🌍', label: 'Track Performance & Usage Analytics (searches, leads, outreach, results) ' },
]

const FE_CORNER_POPUP_REST_MS = 5000
const FE_CORNER_POPUP_SHOW_MIN_MS = 2000
const FE_CORNER_POPUP_SHOW_MAX_MS = 3000

/** Bottom-left activity toast — visible 2–3s, rest 5s, then next (FE page) */
// const FE_CORNER_POPUPS = [
//   {
//     name: 'Sarah M.',
//     place: 'Austin, TX',
//     line: 'just claimed access to Leadszora',
//     img: SA1,
//   },
//   {
//     name: 'James K.',
//     place: 'London, UK',
//     line: 'just viewed the full offer page',
//     img: SA2,
//   },
//   {
//     name: 'Priya S.',
//     place: 'Mumbai, IN',
//     line: 'just started checking out the bonuses',
//     img: SA3,
//   },
//   {
//     name: 'Marcus T.',
//     place: 'Toronto, CA',
//     line: 'just opened the demo section',
//     img: SA1,
//   },
//   {
//     name: 'Elena R.',
//     place: 'Madrid, ES',
//     line: 'just returned to finish checkout',
//     img: SA2,
//   },
//   {
//     name: 'David L.',
//     place: 'Sydney, AU',
//     line: 'just shared Leadszora with a colleague',
//     img: SA3,
//   },
// ]

// const FE_DEMO_VIDEO_SRC = `${process.env.PUBLIC_URL || ''}/fe-demo.mp4`

function FeBonusBoxMock({ src, alt }) {
  useEffect(() => {
    const animatedNodes = Array.from(
      document.querySelectorAll(
        [
          '.fe-top-bar',
          '.fe-main > *',
          '.fe-main section',
          '.fe-main article',
          '.fe-main [class*="__card"]',
          '.fe-main [class*="__item"]',
          '.fe-main [class*="__box"]',
          '.fe-main [class*="gallery__card"]',
          '.fe-main [class*="feature"]',
          '.fe-main [class*="stat"]',
          '.fe-main figure',
          '.fe-main li',
        ].join(', ')
      )
    ).filter((node, index, list) => list.indexOf(node) === index)

    if (!animatedNodes.length) return undefined

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReducedMotion) {
      animatedNodes.forEach((node) => node.classList.add('is-visible'))
      return undefined
    }

    animatedNodes.forEach((node, index) => {
      node.classList.add('fe-reveal-item')
      node.style.setProperty('--fe-reveal-delay', `${Math.min(index * 35, 320)}ms`)
    })

    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          entry.target.classList.add('is-visible')
          observer.unobserve(entry.target)
        })
      },
      { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
    )

    animatedNodes.forEach((node) => revealObserver.observe(node))

    return () => {
      revealObserver.disconnect()
      animatedNodes.forEach((node) => {
        node.classList.remove('fe-reveal-item', 'is-visible')
        node.style.removeProperty('--fe-reveal-delay')
      })
    }
  }, [])

  return (
    <div className="fe-bonus-box">
      <img
        className="fe-bonus-box__img"
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        width={400}
        height={400}
      />

    </div>
  )
}

function FeWorkflowFeatureIcon({ name }) {
  const g = { stroke: '#2e7d32', strokeWidth: 2, fill: 'none', 'aria-hidden': true }
  const s = { width: 28, height: 28, viewBox: '0 0 28 28' }
  switch (name) {
    case 'bolt':
      return (
        <svg {...s} {...g}>
          <path
            d="M16 3L8 15h6l-2 10 10-14h-6l2-8z"
            fill="#2e7d32"
            stroke="none"
          />
        </svg>
      )
    case 'target':
      return (
        <svg {...s} {...g}>
          <circle cx="14" cy="14" r="10" />
          <circle cx="14" cy="14" r="6" />
          <circle cx="14" cy="14" r="2" fill="#2e7d32" stroke="none" />
        </svg>
      )
    case 'building':
      return (
        <svg {...s} {...g}>
          <path d="M6 24V10l8-4v18M14 6l8 4v14H6" />
          <path d="M10 14h4M10 18h4M18 14h2M18 18h2" strokeLinecap="round" />
        </svg>
      )
    case 'team':
      return (
        <svg {...s} {...g}>
          <circle cx="9" cy="11" r="3" />
          <path d="M4 22c0-3 2.5-5 5-5s5 2 5 5" />
          <circle cx="19" cy="11" r="3" />
          <path d="M14 22c0-3 2.5-5 5-5s5 2 5 5" />
        </svg>
      )
    default:
      return null
  }
}

const COUNTDOWN_12H_MS = 12 * 60 * 60 * 1000

/**
 * Time left until the next 12h boundary (from Unix epoch, UTC). Same for every visitor;
 * recalculates from Date.now() each second so refresh does not reset the timer.
 */
function useSynchronized12HourCountdown() {
  const [parts, setParts] = useState({ h: 0, m: 0, s: 0 })

  useEffect(() => {
    const tick = () => {
      const now = Date.now()
      const elapsedInCycle = now % COUNTDOWN_12H_MS
      let diff = COUNTDOWN_12H_MS - elapsedInCycle
      // Restart instantly at 12:00:00 when a cycle completes.
      if (diff === 0) diff = COUNTDOWN_12H_MS
      setParts({
        h: Math.floor(diff / 3600000),
        m: Math.floor((diff % 3600000) / 60000),
        s: Math.floor((diff % 60000) / 1000),
      })
    }
    tick()
    const id = setInterval(tick, 1000)
    return () => clearInterval(id)
  }, [])

  return parts
}

function useTypingEffect(words, typingMs = 80, pauseMs = 2000) {
  const [display, setDisplay] = useState('')
  const [wordIndex, setWordIndex] = useState(0)
  const [deleting, setDeleting] = useState(false)

  useEffect(() => {
    const word = words[wordIndex % words.length]
    let t

    if (!deleting && display.length < word.length) {
      t = setTimeout(() => setDisplay(word.slice(0, display.length + 1)), typingMs)
    } else if (!deleting && display.length === word.length) {
      t = setTimeout(() => setDeleting(true), pauseMs)
    } else if (deleting && display.length > 0) {
      t = setTimeout(() => setDisplay(word.slice(0, display.length - 1)), typingMs / 2)
    } else if (deleting && display.length === 0) {
      setDeleting(false)
      setWordIndex((i) => i + 1)
    }

    return () => clearTimeout(t)
  }, [display, deleting, wordIndex, words, typingMs, pauseMs])

  return display
}

export default function Fe() {
  const offerSectionRef = useRef(null)
  const demoSectionRef = useRef(null)

  const scrollToOfferSection = () => {
    offerSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
  const scrollToDemoSection = () => {
    demoSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
  const { h, m, s } = useSynchronized12HourCountdown()
  const typedTool = useTypingEffect(TYPING_TOOLS)
  // const [feCornerPopupIdx, setFeCornerPopupIdx] = useState(0)
  // const [feCornerPopupVisible, setFeCornerPopupVisible] = useState(true)
  // const [feCornerPopupDismissed, setFeCornerPopupDismissed] = useState(false)

  // useEffect(() => {
  //   if (feCornerPopupDismissed) return undefined

  //   const timers = new Set()
  //   let cancelled = false

  //   const schedule = (fn, ms) => {
  //     const id = window.setTimeout(() => {
  //       timers.delete(id)
  //       if (!cancelled) fn()
  //     }, ms)
  //     timers.add(id)
  //   }

  //   const randomShowMs = () =>
  //     FE_CORNER_POPUP_SHOW_MIN_MS +
  //     Math.floor(Math.random() * (FE_CORNER_POPUP_SHOW_MAX_MS - FE_CORNER_POPUP_SHOW_MIN_MS + 1))

  //   const loop = () => {
  //     setFeCornerPopupVisible(true)
  //     schedule(() => {
  //       setFeCornerPopupVisible(false)
  //       schedule(() => {
  //         setFeCornerPopupIdx((i) => (i + 1) % FE_CORNER_POPUPS.length)
  //         loop()
  //       }, FE_CORNER_POPUP_REST_MS)
  //     }, randomShowMs())
  //   }

  //   loop()

  //   return () => {
  //     cancelled = true
  //     timers.forEach((tid) => window.clearTimeout(tid))
  //     timers.clear()
  //   }
  // }, [feCornerPopupDismissed])

  // const feCornerPopup = FE_CORNER_POPUPS[feCornerPopupIdx]

  return (
    <div className="fe-page">
      <header className="fe-top-bar">
        <div className="fe-top-bar__urgency">
          <span aria-hidden="true">🕒</span>
          <span>HURRY, PRICE INCREASING IN!</span>
        </div>
        <div className="fe-countdown" aria-live="polite">
          <div className="fe-countdown__boxes">
            <div className="fe-countdown__box">
              <div className="fe-countdown__value">{String(h).padStart(2, '0')}</div>
              <div className="fe-countdown__unit">Hours</div>
            </div>
            <div className="fe-countdown__box">
              <div className="fe-countdown__value">{String(m).padStart(2, '0')}</div>
              <div className="fe-countdown__unit">Minutes</div>
            </div>
            <div className="fe-countdown__box">
              <div className="fe-countdown__value">{String(s).padStart(2, '0')}</div>
              <div className="fe-countdown__unit">Seconds</div>
            </div>
          </div>
        </div>
        <div className="fe-top-bar__actions">
          <button type="button" className="fe-btn fe-btn--ghost" onClick={scrollToDemoSection}>
            Demo Video
          </button>
          <a className="fe-btn fe-btn--primary" onClick={scrollToOfferSection}>
            Buy Now
          </a>
        </div>
      </header>

      <main className="fe-main">
        <div className="fe-brand">
          <div className="fe-logo">
            <img
              className="fe-mail-suite__logo-icon"
              src={logo}
              alt="Responsible data use and compliance with business contact regulations"
              loading="lazy"
              width={230}
              height={120}
            />
          </div>
        </div>

        <div className="fe-warning-banner" role="note">
          {/* <span className="fe-warning-banner__stop" aria-hidden="true">
            ⛔
          </span> */}
          <span>
            <span className="fe-warning-banner__stop" style={{ color: '#c62828' }}>🚫 Stop Promoting Low-Converting Tools — Promote One Complete Lead System That Actually Gets Results
            </span>
          </span>
        </div>

        <div className="fe-hero-wrap">
          <div className="fe-hero-badge">All-In-One Lead Finder + CRM + Outreach System</div>
          <section className="fe-hero" aria-labelledby="fe-hero-title">
            <h1 id="fe-hero-title" className="fe-hero__title">
              Promote A High-Demand AI Lead System That Helps Users Find, Manage & Close Leads
            </h1>
            <p className="fe-hero__subtitle">All From One Simple, Beginner-Friendly Dashboard
            </p>
            <div className="fe-hero__tools-line">
              <span className="fe-hero__tools-label fe-hero__tools-label--red">Replace 5+ Expensive Tools With One Complete Lead Engine</span>
            </div>
            <div className="fe-typing-box" aria-label="Rotating examples of tools to replace">
              {typedTool}
              <span className="fe-caret">|</span>
            </div>
            <p className="fe-hero__tagline">
              Discover high-quality business leads, organize them into smart lists, send AI-powered outreach, track follow-ups, and manage the entire sales pipeline — all inside one powerful dashboard.
            </p>
            <p className="fe-hero__tagline1"><b>Perfect for freelancers, agencies, marketers & beginners who want leads, automated outreach, and faster results — without juggling multiple tools or complex setups            </b></p>
            <div className="fe-trust-bar">
              <span>✅ Find targeted leads in seconds (any niche, any location)</span>
              <span className="fe-trust-bar__sep">|</span>
              <span>Save, organize & tag leads with smart lists</span>
              <span className="fe-trust-bar__sep">|</span>
              <span>✉️ Send AI-powered outreach + automated follow-ups
              </span>
              <span className="fe-trust-bar__sep">|</span>
              <spam>📊 Track responses, pipeline & lead status
              </spam>
              <span className="fe-trust-bar__sep">|</span>
              <spam>👥 Manage contacts, workflows & team activity
              </spam>
            </div>

          </section>
        </div>

        <section className="fe-section-offer" aria-labelledby="fe-offer-heading" ref={offerSectionRef}>
          <h2 id="fe-offer-heading" className="fe-visually-hidden">
            Special launch pricing and features
          </h2>
          <div className="fe-section-offer__grid">
            <div className="fe-section-offer__col fe-section-offer__col--left">
              <div className="fe-video-shell">
                <video
                  className="jv-video-frame__player"
                  controls
                  playsInline
                  preload="metadata"
                  poster={feVideoPoster}
                  src={fesalesvideo}
                  title="Demo: high-converting funnel and system"
                >
                  Your browser does not support the video tag.
                </video>
              </div>

              <div className="fe-limited-box">

                <span className="fe-limited-box__text">Early Access Ending Soon – Lock In Your Access Before Price Increases
                </span>
              </div>
              <p className="fe-launch-line">
                Get Instant Access & Start Finding, Managing & Closing Leads Today
              </p>

              <div className="fe-sales-copy" id="buy">
                <p className="fe-sales-copy__lead">Get Instant Access To Your Complete Lead Finder + CRM + Outreach System
                </p>
                <p className="fe-sales-copy__green">No Monthly Fees — Replace Multiple Tools & Save Hundreds Every Month
                </p>
                <p className="fe-sales-copy__mid">
                  <strong>One-Time Payment – </strong> Full Access To Lead Generation, Management & Outreach

                </p>
                <p className="fe-sales-copy__price">
                  Replace Tools Like Apollo, CRM & Email Software — Get Everything In One Dashboard For Just
                  <span className="fe-sales-copy__deal"> $8.99</span>
                </p>
                <p className="fe-sales-copy__fine">No Hidden Costs • No Recurring Charges • Start In Minutes</p>
              </div>
              <hr className="fe-hr" />
              <a
                className="fe-cart-btn"
                href="https://warriorplus.com/o2/buy/sd90jm/s1t6b1/wvd1gk"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={addtocart} alt="Add to Cart" />
              </a>

            </div>

            <div className="fe-section-offer__col fe-section-offer__col--right">
              <ul className="fe-feature-list">
                {OFFER_FEATURES.map((item) => (
                  <li key={item.title} className="fe-feature-list__item">
                    <span className="fe-feature-list__check" aria-hidden="true">
                      ✓
                    </span>
                    <span className="fe-feature-list__body">
                      <strong className="fe-feature-list__title">{item.title}</strong>
                      <span className="fe-feature-list__dash"> — </span>
                      <span className="fe-feature-list__desc">{item.desc}</span>
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section className="fe-payment-plans" aria-labelledby="fe-payment-plans-heading">
          <div className="fe-payment-plans__inner">
            <h2 id="fe-payment-plans-heading" className="fe-payment-plans__title">
              Choose Your Plan &amp; Start Finding Leads Today
            </h2>
            <p className="fe-payment-plans__sub">
              Simple one-time pricing — no monthly fees, no hidden costs.
            </p>
            <div className="fe-payment-plans__grid">
              {FE_PAYMENT_PLANS.map((plan) => (
                <article key={plan.name} className="fe-payment-plans__card">
                  <span className={`fe-payment-plans__badge fe-payment-plans__badge--${plan.badgeTone}`}>
                    {plan.badge}
                  </span>
                  <h3 className="fe-payment-plans__name">{plan.name}</h3>
                  <p className="fe-payment-plans__desc">{plan.desc}</p>
                  <div className="fe-payment-plans__price-block">
                    <span className="fe-payment-plans__price">{plan.price}</span>
                    <span className="fe-payment-plans__price-note">one-time payment</span>
                  </div>
                  <ul className="fe-payment-plans__features">
                    {plan.features.map((row, idx) => (
                      <li
                        key={idx}
                        className={`fe-payment-plans__feature${row.ok ? '' : ' fe-payment-plans__feature--out'}`}
                      >
                        <span className="fe-payment-plans__feature-ic" aria-hidden="true">
                          {row.ok ? '✓' : '✕'}
                        </span>
                        <span className="fe-payment-plans__feature-txt">{row.text}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="fe-payment-plans__cta-wrap">
                    <a className="fe-payment-plans__cta" href={plan.ctaHref}>
                      <span>{plan.cta}</span>
                      <span className="fe-payment-plans__cta-arrow" aria-hidden="true">
                        →
                      </span>
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="fe-traffic-sources" aria-labelledby="fe-traffic-heading">
          <h2 id="fe-traffic-heading" className="fe-traffic-sources__title">
            <span className="fe-traffic-sources__title-green">Turn Leads Into Conversations, Deals & Revenue Using Built-In Outreach Channels</span>
          </h2>
          <p className="fe-traffic-SUBTEXT">Once you find and organize your leads, use leadszora’s built-in outreach system to contact prospects, automate follow-ups, and close deals — all from one dashboard.          </p>
          <div className="fe-traffic-sources__grid">
            {TRAFFIC_SOURCE_CARDS.map((card) => (
              <article key={card.title} className="fe-traffic-sources__card">
                <div className="fe-traffic-sources__img-wrap">
                  <img
                    className="fe-traffic-sources__img"
                    src={card.src}
                    alt={card.alt}
                    loading="lazy"
                    decoding="async"
                    width={900}
                    height={675}
                  />
                  {card.playOverlay ? (
                    <span className="fe-traffic-sources__play" aria-hidden="true">
                      <span className="fe-traffic-sources__play-btn">
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                          <circle cx="12" cy="12" r="11" fill="rgba(0,0,0,0.55)" />
                          <path
                            d="M10 8l8 4-8 4V8z"
                            fill="#fff"
                          />
                        </svg>
                      </span>
                    </span>
                  ) : null}
                </div>
                <p className="fe-traffic-sources__label">{card.title}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="fe-section-why" aria-labelledby="fe-why-heading">
          <div className="fe-section-why__intro">
            <p className="fe-section-why__badge">• Built For Real-World Lead Generation, Management & Outreach •</p>
            <h2 id="fe-why-heading" className="fe-section-why__title">
              Built by <span className="fe-text-green">Experts Who Understand</span> How To Find{' '}
              <span className="fe-text-green">Manage & Close Leads At Scale</span>
            </h2>
            <p className='fe-text-green11'>This isn’t just a lead tool — it’s a complete lead system designed to help you find leads, organize them, automate outreach, and track results from one dashboard.
            </p>
          </div>
          <div className="fe-section-why__grid">
            <div className="fe-section-why__card">
              <h3 className="fe-section-why__card-heading">
                Why Smart Marketers, Agencies & Teams Choose
                <span className="fe-text-green"> Leadszora 2.0</span>
              </h3>
              <p className="fe-section-why__copy">
                Built from real-world experience in lead generation, CRM workflows, and outreach systems — leadszora helps you go from finding leads to managing contacts, sending outreach, and closing deals without using multiple tools.

              </p>
              <ul className="fe-why-mini">
                {WHY_CHOOSE_ITEMS.map((row) => (
                  <li key={row.title} className="fe-why-mini__item">
                    <span className="fe-why-mini__check" aria-hidden="true">
                      ✓
                    </span>
                    <span className="fe-why-mini__text">
                      <strong className="fe-why-mini__title">{row.title}</strong>
                      <span className="fe-why-mini__sub">{row.sub}</span>
                    </span>
                  </li>
                ))}
              </ul>
              <div className="fe-hero__cta-row">
                <a className="fe-btn fe-btn--primary fe-cta-animated fe-hero__cta-primary" onClick={scrollToOfferSection}>
                  <span>Get Instant Access Now</span>
                  <span className="fe-hero__cta-arrow" aria-hidden="true">→</span>
                </a>
              </div>
            </div>
            <div className="fe-section-why__media">
              <div className="fe-why-photo">
                <span className="fe-why-photo__float-check" aria-hidden="true">
                  ✓
                </span>
                <img
                  className="fe-why-photo__img"
                  src={SA1}
                  alt="Professional team collaborating in a modern office with data on screen"
                  loading="lazy"
                  width={960}
                  height={640}
                />
                <div className="fe-why-photo__overlay">
                  <p className="fe-why-photo__overlay-title">Built By A Team Focused On One Goal: Helping You Find, Manage & Convert Leads Consistently: Helping You Find, Manage & Convert Leads Consistently</p>
                  <p className="fe-why-photo__overlay-sub">
                    Helping You Consistently Find, Contact & Convert High-Quality Leads
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="fe-section-why__tagline" role="note">
            <span className="fe-section-why__tagline-icon" aria-hidden="true">
              ✓
            </span>
            <p className="fe-section-why__tagline-text">
              Designed to replace <strong>multiple tools</strong> and simplify your entire lead workflow into{' '}
              <span className="fe-text-green">one system</span>.
            </p>
          </div>
        </section>

        <section className="fe-section-hiw" aria-labelledby="fe-hiw-heading">
          <div className="fe-section-hiw__intro">
            <p className="fe-section-hiw__badge">Simple Lead Generation + Management + Outreach Workflow
            </p>
            <h2 id="fe-hiw-heading" className="fe-section-hiw__title">
              How
              <span className="fe-text-green"> Find, Manage & Close Leads In Minutes
              </span> — Without Multiple Tools

            </h2>
            <p className="fe-section-hiw__sub">
              Follow this step-by-step system to find leads, organize them into smart lists, send AI outreach, track follow-ups, and manage your entire pipeline — all from one dashboard.

            </p>
          </div>

          <div className="fe-hiw-steps">
            <div className="fe-hiw-steps__connector" aria-hidden="true" />
            <div className="fe-hiw-steps__grid">
              {HOW_IT_WORKS_STEPS.map((step) => (
                <article key={step.n} className="fe-hiw-card">
                  <span className="fe-hiw-card__num">{step.n}</span>
                  <div className="fe-hiw-card__icon-ring">
                    <FeHiwIcon name={step.icon} />
                  </div>
                  <h3 className="fe-hiw-card__title">{step.title}</h3>
                  <p className="fe-hiw-card__desc">{step.desc}</p>
                </article>
              ))}
            </div>
          </div>

          <div className="fe-hiw-cta">
            <span className="fe-hiw-cta__check" aria-hidden="true">
              ✓
            </span>
            <p className="fe-hiw-cta__text">
              <strong className="fe-hiw-cta__lead">Ready To Start Finding, Managing & Closing Leads?</strong>{' '}
              <span className="fe-hiw-cta__rest">
                Get Instant Access & Launch Your First Outreach Campaign Today

              </span>
            </p>
          </div>
        </section>

        <section className="fe-section-workflow" aria-labelledby="fe-workflow-heading">
          <div className="fe-section-workflow__intro">
            <p className="fe-section-workflow__badge">● The Smarter Way To Find, Manage & Close Leads ●</p>
            <h2 id="fe-workflow-heading" className="fe-section-workflow__title">
              Replace 5+ Tools With One Complete Lead Finder + CRM + Outreach System
            </h2>
            <p className="fe-section-workflow__line1">
              Stop switching between tools to find leads, manage contacts, send outreach, and track follow-ups

            </p>
            <p className="fe-section-workflow__line2">
              leadszora gives you everything in one place — from lead discovery to management, outreach, and pipeline tracking

            </p>
          </div>

          <div className="fe-workflow-illustration-card">
            <img
              className="fe-workflow-illustration-card__img"
              src={SA2}
              alt="Leadszora workflow illustration using sa2.jpg"
              loading="lazy"
              width={900}
              height={600}
            />
          </div>

          <div className="fe-workflow-features">
            {WORKFLOW_FEATURES.map((f) => (
              <div key={f.key} className="fe-workflow-feature">
                <span className="fe-workflow-feature__icon" aria-hidden="true">
                  <FeWorkflowFeatureIcon name={f.key} />
                </span>
                <span className="fe-workflow-feature__label">{f.label}</span>
              </div>
            ))}
          </div>

          <div className="fe-workflow-stats" role="list">
            {WORKFLOW_STATS.map((row) => (
              <div key={row.label} className="fe-workflow-stat" role="listitem">
                <span className="fe-workflow-stat__value">{row.value}</span>
                <span className="fe-workflow-stat__label">{row.label}</span>
              </div>
            ))}
          </div>

          <div className="fe-workflow-banner">
            <span className="fe-workflow-banner__icon-wrap" aria-hidden="true">
              <span className="fe-workflow-banner__bolt">⚡</span>
            </span>
            <p className="fe-workflow-banner__text">
              <strong>Ready to simplify your lead workflow & close more deals? </strong> Get started with leadszora today
            </p>
          </div>
        </section>

        <section className="fe-section-compliance" aria-labelledby="fe-compliance-heading">
          <h2 id="fe-compliance-heading" className="fe-compliance__title">
            Built With Compliance In Mind — Safe, Responsible & Transparent Lead Usage
          </h2>
          <div className="fe-compliance__box">
            <p className="fe-compliance__line1">
              leadszora works with publicly available business data and is designed to support responsible, ethical outreach practices.

            </p>
            <p className="fe-compliance__line2">
              Users are expected to follow applicable regulations such as GDPR, CAN-SPAM, and local email marketing laws when contacting prospects.

            </p>
            <p className="fe-compliance__line1">
              The platform helps you organize, manage, and reach out to leads — while keeping your workflow compliant and structured.

            </p>
          </div>
          <div className="fe-compliance__arrow" aria-hidden="true" />
          <figure className="fe-compliance__figure">
            <img
              className="fe-compliance__img"
              src={SA3}
              alt="Responsible data use and compliance with business contact regulations"
              loading="lazy"
              width={1200}
              height={675}
            />
          </figure>

          <div className="fe-compliance__notice" role="note">
            <span className="fe-compliance__notice-icon" aria-hidden="true">
              i
            </span>
            <p className="fe-compliance__notice-text">
              leadszora does not provide private or scraped personal data - all information is based on
              publicly available business sources.
            </p>
          </div>
        </section>

        <section className="fe-section-leadgen" aria-labelledby="fe-leadgen-heading">
          <div className="fe-leadgen-intro">
            <p className="fe-leadgen-pill">
              The Future Of Lead Generation, Management & Outreach — All In One Dashboard

            </p>
            <h2 id="fe-leadgen-heading" className="fe-leadgen-hero-title">
              Find, Organize, Contact & Convert High-Quality Leads — Without Switching Tools

            </h2>
            <p className="fe-leadgen-hero-sub">
              Discover leads, save them into smart lists, send AI-powered outreach, and track follow-ups — all from one centralized system

            </p>
          </div>

          <div className="fe-leadgen-panel">
            <div className="fe-leadgen-panel__head">
              <p className="fe-leadgen-panel-pill">
                All-In-One Lead Discovery, Management & Outreach System

              </p>
              <h3 className="fe-leadgen-panel__title">
                Build A Consistent Flow Of Leads, Conversations & Clients — Without Complex Tools Or Tech Skills
              </h3>
            </div>

            <div className="fe-leadgen-body">
              <div className="fe-leadgen-copy">
                <p>
                  Find targeted business leads using AI search, save them into smart lists, tag and organize them, and reach out using AI-generated messages — all from one simple platform.

                </p>
                <p>
                  Manage your entire workflow in one place — from lead discovery, outreach, follow-ups, to response tracking and pipeline management.
                </p>
                <ul className="fe-leadgen-list">
                  {LEADGEN_BULLETS.map((line) => (
                    <li key={line} className="fe-leadgen-list__item">
                      <span className="fe-leadgen-list__check" aria-hidden="true">
                        ✓
                      </span>
                      {line}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="fe-leadgen-collage">
                <div className="fe-leadgen-collage__top">
                  {LEADGEN_COLLAGE.filter((c) => c.layout !== 'bc').map((c) => (
                    <figure key={c.bubble} className={`fe-leadgen-photo fe-leadgen-photo--${c.layout}`}>
                      <img className="fe-leadgen-photo__img" src={c.src} alt={c.alt} loading="lazy" />
                      <figcaption className="fe-leadgen-bubble">{c.bubble}</figcaption>
                    </figure>
                  ))}
                </div>
                {LEADGEN_COLLAGE.filter((c) => c.layout === 'bc').map((c) => (
                  <figure key={c.bubble} className="fe-leadgen-photo fe-leadgen-photo--bc">
                    <img className="fe-leadgen-photo__img" src={c.src} alt={c.alt} loading="lazy" />
                    <figcaption className="fe-leadgen-bubble">{c.bubble}</figcaption>
                  </figure>
                ))}
              </div>
            </div>

            <div className="fe-leadgen-gallery">
              <div className="fe-leadgen-gallery__card fe-leadgen-gallery__card--env">

                <img
                  className="fe-leadgen-gallery__img"
                  src={LC4}
                  alt="Responsible data use and compliance with business contact regulations"
                  loading="lazy"
                  width={1200}
                  height={675}
                />
              </div>
              <div className="fe-leadgen-gallery__card fe-leadgen-gallery__card--dash">
                <img
                  className="fe-leadgen-gallery__img"
                  src={LC5}
                  alt="Responsible data use and compliance with business contact regulations"
                  loading="lazy"
                  width={1200}
                  height={675}
                />
              </div>
              <div className="fe-leadgen-gallery__card fe-leadgen-gallery__card--form">
                <div className="fe-leadgen-mock-form">
                  <img
                    className="fe-leadgen-gallery__img"
                    src={LC6}
                    alt="Responsible data use and compliance with business contact regulations"
                    loading="lazy"
                    width={1200}
                    height={675}
                  />
                </div>
              </div>
              <div className="fe-leadgen-gallery__card fe-leadgen-gallery__card--flow">
                <img
                  className="fe-leadgen-gallery__img"
                  src={LC7}
                  alt="Responsible data use and compliance with business contact regulations"
                  loading="lazy"
                  width={1200}
                  height={675}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="fe-section-mail-suite" aria-labelledby="fe-mail-heading">
          <div className="fe-mail-suite__wrap">
            <p className="fe-mail-suite__badge">Built-In AI Outreach, Follow-Up & Pipeline Management System
            </p>
            <h2 id="fe-mail-heading" className="fe-mail-suite__title">
              Reach Out, Follow Up & Close Leads With AI-Powered Messages — All In One Dashboard

            </h2>

            <div className="fe-mail-suite__row">
              <div className="fe-mail-suite__col fe-mail-suite__col--text">
                <div className="fe-mail-suite__logo" aria-hidden="true">
                  {/* <svg className="fe-mail-suite__logo-icon" width="36" height="36" viewBox="0 0 40 40">
                    <circle cx="20" cy="20" r="18" fill="#4caf50" />
                    <path
                      d="M20 8v6M20 26v6M8 20h6M26 20h6M12 12l4 4M24 24l4 4M28 12l-4 4M12 28l4-4"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                  <span className="fe-mail-suite__logo-text">Leadszora</span> */}

                  <img
                    className="fe-mail-suite__logo-icon"
                    src={logo}
                    alt="Responsible data use and compliance with business contact regulations"
                    loading="lazy"
                    width={230}
                    height={120}
                  />
                </div>
                <p className="fe-mail-suite__lead">
                  Create and send AI-powered personalized outreach messages, schedule smart follow-ups, and track every conversation — all from one dashboard.
                </p>
                <p className="fe-mail-suite__sub">
                  No need for multiple tools — manage outreach, responses, pipeline, and follow-ups in one simple, organized system.

                </p>
                <ul className="fe-mail-suite__list">
                  {MAIL_SUITE_BULLETS.map((line) => (
                    <li key={line} className="fe-mail-suite__list-item">
                      <span className="fe-mail-suite__list-check" aria-hidden="true">
                        ✓
                      </span>
                      {line}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="fe-mail-suite__col fe-mail-suite__col--visual">
                <div className="fe-mail-suite__visual-inner">

                  <img
                    className="fe-mail-suite__team"
                    src={businessProfessionals2}
                    alt="Smiling business professionals collaborating"
                    loading="lazy"
                    width={900}
                    height={900}
                  />
                  {/* <div className="fe-mail-suite__cta-wrap">
                    <button type="button" className="fe-mail-suite__generate">
                      GENERATE
                    </button>
                    <span className="fe-mail-suite__cursor" aria-hidden="true" />
                  </div> */}
                </div>
              </div>
            </div>

            <div className="fe-mail-suite__grid">
              <div className="fe-mail-suite__card fe-mail-suite__card--devices">
                <img
                  className="fe-mail-suite__devices-img"
                  src={mailsuite1}
                  alt="Business professionals"
                  loading="lazy"
                  width={100}
                  height={100}
                />
              </div>

              <div className="fe-mail-suite__card fe-mail-suite__card--devices">
                <img
                  className="fe-mail-suite__devices-img"
                  src={mailsuite2}
                  alt="Business professionals"
                  loading="lazy"
                  width={100}
                  height={100}
                />
              </div>

              <div className="fe-mail-suite__card fe-mail-suite__card--devices">
                <img
                  className="fe-mail-suite__devices-img"
                  src={mailsuite3}
                  alt="Business professionals"
                  loading="lazy"
                  width={100}
                  height={100}
                />
              </div>

              <div className="fe-mail-suite__card fe-mail-suite__card--devices">
                <img
                  className="fe-mail-suite__devices-img"
                  src={mailsuite4}
                  alt="Business professionals"
                  loading="lazy"
                  width={100}
                  height={100}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="fe-section-research-discovery" aria-labelledby="fe-research-heading">
          <div className="fe-research-discovery">
            <header className="fe-research-discovery__head">
              <p className="fe-research-discovery__label">
                AI-Powered Lead Discovery & Smart Data Engine

              </p>
              <h2 id="fe-research-heading" className="fe-research-discovery__title">
                Find, Extract & Organize High-Quality Leads In Any Niche — In Seconds

              </h2>
            </header>

            <div className="fe-research-discovery__row">
              <div className="fe-research-discovery__col fe-research-discovery__col--text">
                <p className="fe-research-discovery__lead">
                  Instantly discover targeted business leads using AI-powered search, smart filters, and real-time data extraction — all from one dashboard.

                </p>
                <p className="fe-research-discovery__lead">
                  Find, verify, and organize ready-to-use prospects for outreach, campaigns, or client acquisition — without manual research or scraping tools.

                </p>
                <ul className="fe-research-discovery__list">
                  {RESEARCH_DISCOVERY_POINTS.map((line) => (
                    <li key={line} className="fe-research-discovery__item">
                      <span className="fe-research-discovery__check" aria-hidden="true">
                        ✓
                      </span>
                      {line}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="fe-research-discovery__col fe-research-discovery__col--visual">
                <div className="fe-research-visual" aria-hidden="true">
                  {/* <div className="fe-research-visual__laptop">
                    <div className="fe-research-visual__laptop-screen">
                      <span className="fe-research-visual__seo-title">SEO CONTENT</span>
                      <span className="fe-research-visual__seo-lines" />
                    </div>
                    <div className="fe-research-visual__laptop-base" />
                  </div> */}
                  <img
                    className="fe-research-visual__avatar"
                    src={ResearchDiscovery2}
                    alt=""
                    loading="lazy"
                    width={280}
                    height={280}
                  />
                  {/* <span className="fe-research-visual__badge fe-research-visual__badge--ai">AI</span>
                  <span className="fe-research-visual__badge fe-research-visual__badge--seo">
                    ⚙ SEO
                  </span>
                  <button type="button" className="fe-research-visual__generate">
                    <span className="fe-research-visual__sparkle-btn" aria-hidden="true">
                      ✦
                    </span>
                    Generate
                  </button>
                  <span className="fe-research-visual__floater fe-research-visual__floater--star">
                    ✦
                  </span>
                  <span className="fe-research-visual__floater fe-research-visual__floater--bubble">
                    💬
                  </span> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="fe-section-features-no" aria-labelledby="fe-features-no-heading">
          <div className="fe-features-no__inner">
            <p className="fe-features-no__badge">Everything You Need To Find, Manage & Convert Leads — Without The Usual Headaches
            </p>
            <h2 id="fe-features-no-heading" className="fe-features-no__title">
              Run Your Lead Generation & Outreach Without Stress, Confusion, Or Tool Overload

            </h2>
            <p className="fe-features-no__title1">No complicated setups. No juggling tools. No steep learning curves.
            </p>
            <p className="fe-features-no__title1">Just one simple system to find leads, organize them, send outreach, track follow-ups, and manage your entire pipeline daily.

            </p>
            <div className="fe-features-no__grid">
              {FEATURES_NO_MORE.map((item) => (
                <article key={item.caption} className="fe-features-no__card">
                  <img
                    className="fe-features-no__img"
                    src={item.src}
                    alt={item.alt}
                    loading="lazy"
                    width={640}
                    height={400}
                  />
                  <p className="fe-features-no__caption">
                    <span className="fe-features-no__no">No</span> {item.title}
                  </p>
                  <span >{item.caption}</span>
                </article>

              ))}
            </div>
            <p className="fe-features-no__title2"><b>Stop wasting time switching between tools — start using one complete system that helps you find, manage, contact, and convert leads daily.
            </b></p>
          </div>
        </section>

        <section className="fe-section-comparison" aria-labelledby="fe-comparison-heading">
          <h2 id="fe-comparison-heading" className="fe-comparison__title">
            Choose How You Want To Find, Manage & Convert Leads — And Grow Your Business Faster

          </h2>
          <div className="fe-comparison__grid">
            <article className="fe-comparison__card fe-comparison__card--bad">
              <span className="fe-comparison__badge fe-comparison__badge--bad">Choice 1</span>
              <div className="fe-comparison__visual">
                <img
                  className="fe-comparison__person"
                  src={comparisonBad}
                  alt="Person looking stressed at work"
                  loading="lazy"
                  width={640}
                  height={480}
                />
              </div>
              <h3 className="fe-comparison__card-title">The Old, Manual & Disconnected Way
              </h3>
              <ul className="fe-comparison__list">
                {COMPARISON_BAD_POINTS.map((line) => (
                  <li key={line} className="fe-comparison__item fe-comparison__item--bad">
                    <span className="fe-comparison__mark fe-comparison__mark--bad" aria-hidden="true">
                      ✕
                    </span>
                    {line}
                  </li>
                ))}
              </ul>
              <div className="fe-comparison__outcome fe-comparison__outcome--bad">
                RESULT: Wasted Time, Lost Leads, Missed Follow-Ups & Unpredictable Growth

              </div>
            </article>

            <article className="fe-comparison__card fe-comparison__card--good">
              <span className="fe-comparison__badge fe-comparison__badge--good">Choice 2</span>
              <div className="fe-comparison__visual">
                <img
                  className="fe-comparison__person"
                  src={comparisonGood}

                  alt="Confident professional smiling with arms open"
                  loading="lazy"
                  width={640}
                  height={480}
                />
              </div>
              <h3 className="fe-comparison__card-title">The Smart, AI-Powered Leadszora System
              </h3>
              <ul className="fe-comparison__list">
                {COMPARISON_GOOD_POINTS.map((line) => (
                  <li key={line} className="fe-comparison__item fe-comparison__item--good">
                    <span className="fe-comparison__mark fe-comparison__mark--good" aria-hidden="true">
                      ✓
                    </span>
                    {line}
                  </li>
                ))}
              </ul>
              <div className="fe-comparison__outcome fe-comparison__outcome--good">
                Perfect for freelancers, agencies, teams & anyone who wants predictable leads and consistent client growth

              </div>
            </article>
          </div>
          <p className="fe-micro-cta-text"><b>The choice is simple — keep juggling tools and losing leads, or switch to one complete system that helps you find, manage, and convert leads daily.
          </b></p>
        </section>

        <section className="fe-section-bonuses" aria-labelledby="fe-bonuses-heading">
          <h2 id="fe-bonuses-heading" className="fe-visually-hidden">
            Limited-time bonuses
          </h2>
          <div className="fe-bonuses__grid">
            {BONUSES.map((b) => (
              <article key={b.badge} className="fe-bonuses__card">
                <span className="fe-bonuses__badge">{b.badge}</span>
                <FeBonusBoxMock src={b.boxImg} alt={b.boxImgAlt} />
                <h3 className="fe-bonuses__title">{b.title}</h3>
                <div className="fe-bonuses__body">
                  {b.body.map((line, i) => (
                    <p key={`${b.badge}-${i}`} className="fe-bonuses__line">
                      {line}
                    </p>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="fe-section-now-i-know" aria-labelledby="fe-now-i-know-heading">
          <div className="fe-now-i-know__inner">
            <p className="fe-now-i-know__badge">Still Struggling To Get Consistent Leads?
            </p>
            <h2 id="fe-now-i-know-heading" className="fe-now-i-know__title">
              You're Using Multiple Tools… But Still Not Getting Consistent Leads Or Clients

            </h2>
            <p className="fe-now-i-know__sub">
              You've tried different tools, platforms, and strategies…
              <br />but your leads, outreach, and results still feel scattered, inconsistent, and hard to manage.
            </p>
            <p className="fe-now-i-know__catch">Here’s The Real Problem — You Don’t Have A System
            </p>
            <div className="fe-now-i-know__arrow" aria-hidden="true" />
            <p className="fe-now-i-know__dashed">
              Even after paying for multiple tools every month… you still don’t have one system to manage everything

            </p>
            <p className="fe-now-i-know__warn">
              <span aria-hidden="true">👉</span>{' '}
              <strong>You’re Still Facing These Daily Problems:
              </strong>
            </p>
            <div className="fe-now-i-know__grid">
              {NOW_I_KNOW_CARDS.map((c) => (
                <article key={c.text} className="fe-now-i-know__card">
                  <img
                    className="fe-now-i-know__img"
                    src={c.src}
                    alt={c.alt}
                    loading="lazy"
                    width={640}
                    height={400}
                  />
                  <p className="fe-now-i-know__card-text">{c.title} <br />{c.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="fe-section-lead-simple" aria-labelledby="fe-lead-simple-heading">
          <div className="fe-lead-simple__inner">
            <p className="fe-lead-simple__badge">Your Complete Lead Generation, Management & Outreach System
            </p>
            <p className="fe-lead-simple__intro">
              Finding, managing, contacting, and tracking leads used to require multiple tools, messy workflows, and hours of manual work

            </p>
            <p className="fe-lead-simple__intro fe-lead-simple__intro--strong">
              <strong>
                Not anymore — leadszora brings everything into one AI-powered system (from lead discovery → outreach → follow-up → tracking)

              </strong>
            </p>
            <h2 id="fe-lead-simple-heading" className="fe-lead-simple__headline">
              <span className="fe-lead-simple__headline-text">leadszora Helps You Find, Organize, Contact & Convert Leads — All In One Smart Dashboard
              </span>
            </h2>
            <div className="fe-lead-simple__arrows" aria-hidden="true">
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <span key={n} className="fe-lead-simple__arrow">
                  ▼
                </span>
              ))}
            </div>
            <div className="fe-lead-simple__grid">
              {LEAD_GEN_SIMPLE_FEATURES.map((f) => (
                <div key={f.label} className="fe-lead-simple__card">
                  <div className="fe-lead-simple__icon-wrap">
                    <span className="fe-lead-simple__emoji" aria-hidden="true">
                      {f.emoji}
                    </span>
                    {f.showAt && (
                      <span className="fe-lead-simple__at" aria-hidden="true">
                        @
                      </span>
                    )}
                  </div>
                  <p className="fe-lead-simple__card-label">{f.label}</p>
                </div>
              ))}
            </div>
            <p className="fe-lead-simple__mid">
              Find targeted leads, organize them with smart lists & tags, send outreach, set follow-ups, and track everything — without switching between tools

            </p>
            <div className="fe-lead-simple__highlight">
              <p className="fe-lead-simple__highlight-line fe-lead-simple__highlight-line--green">
                <strong>leadszora gives you full control over your entire lead workflow — from finding leads to closing clients

                </strong>
              </p>
              <p className="fe-lead-simple__highlight-line fe-lead-simple__highlight-line--green">
                <strong>
                  No more tool switching. No more missed follow-ups. No more messy data.
                </strong>
              </p>
              <p className="fe-lead-simple__highlight-line fe-lead-simple__highlight-line--green">
                <strong>
                  Just one simple system to find, manage, contact, and convert leads consistently
                </strong>
              </p>
              <p className="fe-lead-simple__highlight-line fe-lead-simple__highlight-line--black">
                <strong>Simple To Start. Powerful To Scale. Built For Daily Results.
                </strong>
              </p>
            </div>
          </div>
        </section>

        <section className="fe-section-imagine" aria-labelledby="fe-imagine-heading">
          <div className="fe-imagine__inner">
            <h2 id="fe-imagine-heading" className="fe-imagine__headline">
              Imagine Having One Simple System That Brings You Leads, Conversations & Clients Consistently

            </h2>
            <div className="fe-imagine__cta-box">
              <p className="fe-imagine__cta-line">
                <strong>What if you could find, organize, contact, and follow up with high-quality leads every day — without switching tools, wasting time, or missing opportunities?
                </strong>
              </p>
            </div>

            <div className="fe-imagine__two-col">
              <div className="fe-imagine__col fe-imagine__col--text">
                <p className="fe-imagine__p">
                  <strong>This isn’t just another tool  —</strong> it’s a complete lead management & outreach system designed to help you take action daily

                </p>
                <p className="fe-imagine__p fe-imagine__p--lead">
                  <strong>With Leadszora, you can :</strong>
                </p>
                <ul className="fe-imagine__list">
                  <li>Find targeted leads in seconds (any niche, location, industry) </li>
                  <li>Save leads into smart lists & organize with tags (Hot, Contacted, Follow-up) </li>
                  <li>Generate AI-powered outreach messages instantly </li>
                  <li>Send outreach & schedule follow-ups from one dashboard </li>
                  <li>Track lead status (New, Contacted, Interested, Closed) </li>
                  <li>Never miss a follow-up with built-in reminders</li>
                  <li>Manage all leads, conversations & activities in one place </li>
                </ul>
                <p className="fe-imagine__p">
                  Instead of guessing what to do next, you follow a clear, simple system that helps you consistently turn leads into conversations and clients.
                </p>

              </div>
              <div className="fe-imagine__col fe-imagine__col--visual">
                <div className="fe-imagine__photo-frame">
                  <img
                    className="fe-imagine__img"
                    src={imagine1}
                    alt="Smiling professional celebrating growth and success"
                    loading="lazy"
                    decoding="async"
                    width={900}
                    height={675}
                  />
                </div>
              </div>
            </div>


          </div>
        </section>

        <section className="fe-section-commercial" aria-labelledby="fe-commercial-heading">
          <div className="fe-commercial__inner">
            <p className="fe-commercial__badge">Unlock More Ways To Use leadszora & Generate Revenue
            </p>
            <h2 id="fe-commercial-heading" className="fe-commercial__title">
              Get Commercial Use Access — Use leadszora For Your Own Business, Clients & Lead Generation Services

            </h2>
            <p className="fe-commercial__sub">
              Use leadszora to find leads, manage outreach, close clients, and even offer lead generation services to others


            </p>

            <div className="fe-commercial__box">
              <div className="fe-commercial__col fe-commercial__col--text">
                <p className="fe-commercial__p">
                  With leadszora, you're not limited to personal use — you can use it to run client projects, outreach campaigns, or even start your own lead generation service

                </p>
                <p className="fe-commercial__p">
                  This gives you flexibility to apply the system in real-world scenarios — whether you're working solo or with clients.
                </p>
                <ul className="fe-commercial__list">
                  {COMMERCIAL_LICENSE_BULLETS.map((line) => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>
                <p className="fe-commercial__p1">
                  <b>Whether you're building your own pipeline or working with clients, leadszora gives you a complete system to find, manage, contact, and convert leads — all from one place
                  </b>
                </p>
              </div>
              <div className="fe-commercial__col fe-commercial__col--visual">
                <div className="fe-commercial__visual">
                  <span className="fe-commercial__glow" aria-hidden="true" />
                  <span className="fe-commercial__orb fe-commercial__orb--a" aria-hidden="true" />
                  <span className="fe-commercial__orb fe-commercial__orb--b" aria-hidden="true" />
                  <span className="fe-commercial__orb fe-commercial__orb--c" aria-hidden="true" />
                  <span className="fe-commercial__spark" aria-hidden="true" />
                  <img
                    className="fe-commercial__img"
                    src={commercial1}
                    alt="Entrepreneur celebrating success with a rewarding commercial opportunity"
                    loading="lazy"
                    decoding="async"
                    width={1000}
                    height={750}
                  />

                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="fe-section-dark-cta" aria-labelledby="fe-dark-cta-heading">
          <div className="fe-section-dark-cta__inner">
            <p className="fe-dark-cta__line1">
              One-Time Payment • No Monthly Fees • Full System Access Included

            </p>
            <h2 id="fe-dark-cta-heading" className="fe-dark-cta__line2">
              <span className="fe-dark-cta__w">Limited-Time </span>
              <span className="fe-dark-cta__r"> Launch Offer – Get Full Access </span>
              <span className="fe-dark-cta__g">To leadszora Today For Just $8.99
              </span>
            </h2>
            <h2 id="fe-dark-cta-heading" className="fe-dark-cta__line2">
              <span className="fe-dark-cta__r"> Launch Offer – Get Full Access </span>
              <span className="fe-dark-cta__g">To leadszora Today For Just $8.99
              </span>
            </h2>
            <button type="button" className="fe-dark-cta__btn fe-cta-animated" onClick={scrollToOfferSection}>
              Get Instant Access To leadszora Now

            </button>


            <p className="fe-dark-cta__line1">
              Get Instant Access • Start In Minutes • No Technical Skills Required
            </p>
          </div>
        </section>
        <section className="fe-section-awesome" aria-labelledby="fe-awesome-heading">
          <div className="fe-awesome__inner">
            <h2 id="fe-awesome-heading" className="fe-awesome__title">
              Plus, Everything You Need To Start Fast & Scale Without Confusion

            </h2>
            <p className="fe-awesome__pill">Designed To Be Simple, Beginner-Friendly & Powerful For Daily Use
            </p>
            <div className="fe-awesome__grid">
              {AWESOME_FEATURES_CARDS.map((card) => (
                <article key={card.caption} className="fe-awesome__card">
                  <div className="fe-awesome__img-wrap">
                    <img
                      className="fe-awesome__img"
                      src={card.src}
                      alt={card.alt}
                      loading="lazy"
                      decoding="async"
                      width={720}
                      height={480}
                    />
                  </div>
                  <p className="fe-awesome__caption">{card.caption} <br /> {card.title}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="fe-section-traffic-audience" aria-labelledby="fe-traffic-audience-heading">
          <div className="fe-traffic-audience__inner">
            <h2 id="fe-traffic-audience-heading" className="fe-traffic-audience__title">
              Perfect For Anyone Who Wants Consistent Leads & Clients

            </h2>
            <div className="fe-traffic-audience__grid">
              {TRAFFIC_AUDIENCE_CARDS.map((card) => (
                <article key={card.label} className="fe-traffic-audience__card">
                  <div className="fe-traffic-audience__avatar">
                    <img
                      className="fe-traffic-audience__img"
                      src={card.src}
                      alt={card.alt}
                      loading="lazy"
                      decoding="async"
                      width={400}
                      height={400}
                    />
                  </div>
                  <p className="fe-traffic-audience__label">{card.label}</p>
                  <p className="fe-traffic-audience__title1">{card.title}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="fe-section-winlose" aria-labelledby="fe-winlose-heading">
          <div className="fe-winlose__inner">
            <h2 id="fe-winlose-heading" className="fe-winlose__title">
              The Choice Is Yours — Keep Struggling With Multiple Tools Or Switch To One Complete Lead System

            </h2>
            <div className="fe-winlose__pills" role="group" aria-label="Winning or losing side">
              <span className="fe-winlose__pill fe-winlose__pill--win">Smart System (leadszora)
              </span>
              <span className="fe-winlose__or" aria-hidden="true">
                OR
              </span>
              <span className="fe-winlose__pill fe-winlose__pill--lose">Old Way (Multiple Tools)
              </span>
            </div>

            <div className="fe-winlose__cards">
              <article className="fe-winlose__card fe-winlose__card--win">
                <header className="fe-winlose__head fe-winlose__head--win">
                  🥳 Winning Side 😍
                </header>
                <ul className="fe-winlose__list fe-winlose__list--win">
                  {WINNING_SIDE_LINES.map((line) => (
                    <li key={line} className="fe-winlose__item">
                      <span className="fe-winlose__emoji" aria-hidden="true">
                        😊
                      </span>
                      <span className="fe-winlose__text">{line}</span>
                    </li>
                  ))}
                </ul>
              </article>

              <article className="fe-winlose__card fe-winlose__card--lose">
                <header className="fe-winlose__head fe-winlose__head--lose">
                  😟 Losing Side 😢
                </header>
                <ul className="fe-winlose__list fe-winlose__list--lose">
                  {LOSING_SIDE_LINES.map((line) => (
                    <li key={line} className="fe-winlose__item">
                      <span className="fe-winlose__emoji" aria-hidden="true">
                        ☹️
                      </span>
                      <span className="fe-winlose__text">{line}</span>
                    </li>
                  ))}
                </ul>
              </article>
            </div>
          </div>
        </section>

        <section className="fe-section-workflow-cmp" aria-labelledby="fe-workflow-cmp-heading">
          <div className="fe-workflow-cmp__inner">
            <p className="fe-workflow-cmp__badge">See The Difference Between Chaos & A Complete Lead System
            </p>
            <h2 id="fe-workflow-cmp-heading" className="fe-workflow-cmp__title">
              From Scattered Lead Workflows To One Simple Daily Lead System

            </h2>
            <div className="fe-workflow-cmp__cards">
              <article className="fe-workflow-cmp__card fe-workflow-cmp__card--before">
                <p className="fe-workflow-cmp__eyebrow fe-workflow-cmp__eyebrow--before">
                  BEFORE: Multiple Tools, Messy Workflows
                  <span aria-hidden="true">❌</span>
                </p>
                <p className="fe-workflow-cmp__subtitle">Using separate tools for leads, outreach, tracking & follow-ups
                </p>
                <ul className="fe-workflow-cmp__list">
                  {WORKFLOW_BEFORE_LINES.map((line) => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>
              </article>

              <article className="fe-workflow-cmp__card fe-workflow-cmp__card--after">
                <p className="fe-workflow-cmp__eyebrow fe-workflow-cmp__eyebrow--after">
                  AFTER: One Smart Dashboard For Everything
                  <span aria-hidden="true">✅</span>
                </p>
                <p className="fe-workflow-cmp__subtitle">One simple dashboard for everything</p>
                <ul className="fe-workflow-cmp__list">
                  {WORKFLOW_AFTER_LINES.map((line) => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>
              </article>
            </div>
          </div>
        </section>

        <section className="fe-section-biz-machine" aria-labelledby="fe-biz-machine-heading">
          <div className="fe-biz-machine__inner">
            <h2 id="fe-biz-machine-heading" className="fe-biz-machine__title">
              <span className="fe-biz-machine__title-green">Turn leadszora Into Your Daily Lead
              </span>
              <span className="fe-biz-machine__title-strong">Generation, Management & Outreach System
              </span>
            </h2>
            <p className="fe-biz-machine__sub">
              Use leadszora to find leads, organize them, send outreach, set follow-ups, and track everything — all from one simple dashboard

            </p>
            <p className="fe-biz-machine__disclaimer">
              Built to help you take daily action — from finding leads to managing conversations and closing opportunities

            </p>

            <div className="fe-biz-machine__grid">
              {BUSINESS_MACHINE_CARDS.map((card) => (
                <article
                  key={card.title}
                  className={
                    card.glow
                      ? 'fe-biz-machine__card fe-biz-machine__card--glow'
                      : 'fe-biz-machine__card'
                  }
                >
                  <div className="fe-biz-machine__img-wrap">
                    <img
                      className="fe-biz-machine__img"
                      src={card.src}
                      alt={card.alt}
                      loading="lazy"
                      decoding="async"
                      width={720}
                      height={450}
                    />
                  </div>
                  <h3 className="fe-biz-machine__card-title">{card.title}</h3>
                  <p className="fe-biz-machine__card-desc">{card.desc}</p>
                </article>
              ))}
            </div>
          </div>
        </section>
        <section className="fe-section-fast-bonus" aria-labelledby="fe-fast-bonus-heading">
          <div className="fe-fast-bonus__inner">
            <p id="fe-fast-bonus-heading" className="fe-fast-bonus__text">
              Fast Action Bonuses Included
              <br />
              Get More Value When You Get Started Today
            </p>
          </div>
        </section>
        <section className="fe-section-access-anywhere" aria-labelledby="fe-access-anywhere-heading">
          <div className="fe-access-anywhere__inner">
            <p className="fe-access-anywhere__pill">Work From Anywhere — Manage Leads, Outreach & Clients Anytime
            </p>
            <h2 id="fe-access-anywhere-heading" className="fe-access-anywhere__title">
              Manage Your Leads, Outreach & Follow-Ups From Anywhere — Without Losing Control

            </h2>
            <p className="fe-access-anywhere__pill1">Whether you're working from home, office, or on the go — your entire lead generation, outreach, and tracking system is always accessible
            </p>
            <p className="fe-access-anywhere__arrows" aria-hidden="true">
              ↓ ↓ ↓ ↓ ↓ ↓
            </p>

            <div className="fe-access-anywhere__grid">
              {ACCESS_ANYWHERE_IMAGES.map((item) => (
                <figure key={item.alt} className="fe-access-anywhere__card">
                  <img
                    className="fe-access-anywhere__img"
                    src={item.src}
                    alt={item.alt}
                    loading="lazy"
                    decoding="async"
                    width={900}
                    height={520}
                  />
                </figure>
              ))}
            </div>

            <div className="fe-access-anywhere__tagline">
              <span className="fe-access-anywhere__tagline-text">Stay Consistent With Your Leads, Outreach & Follow-Ups</span>
              <span >
                — </span>
              <span className="fe-access-anywhere__brand"> No Matter Where You Work From — Your System Works With You
              </span>
            </div>
          </div>
        </section>


      </main>

      <section className="fe-section-demo-video" aria-labelledby="fe-demo-video-heading" ref={demoSectionRef}>
        <div className="fe-section-demo-video__inner">
          <h2 id="fe-demo-video-heading" className="fe-section-demo-video__title">
            Watch The Demo In Action
          </h2>
          <p className="fe-section-demo-video__sub">
            See how Leadzora helps you find, manage, and close leads faster.
          </p>

          <div className="fe-section-demo-video__frame">
            <video
              className="fe-section-demo-video__player"
              controls
              playsInline
              preload="metadata"
              poster={demothumbnail}
              src={fedemovideo}
              title="Leadzora demo video"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>



      <section
        id="fe-section-pricing-pro"
        className="fe-section-pricing-pro"
        aria-labelledby="fe-pricing-pro-heading"
      >
        <div className="fe-pricing-pro__inner">
          <h2 id="fe-pricing-pro-heading" className="fe-pricing-pro__title">
            Get Instant Access To Your Complete Lead Generation, Management & Outreach System

          </h2>
          <p className="fe-pricing-pro__subtitle">
            Find, organize, contact, and track targeted leads — all from one simple AI-powered dashboard

          </p>
          <p className="fe-pricing-pro__meta"> One-Time Payment • No Monthly Fees • Full System Access Included
          </p>

          <article className="fe-pricing-pro__card" id="buy">
            <p className="fe-pricing-pro__plan">leadszora – All-In-One Lead Generation, Lead Management & Outreach System (Commercial Use Included)
            </p>

            <div className="fe-pricing-pro__hero" aria-hidden="true">
              <div className="fe-pricing-pro__hero-main">Leadszora 2.0</div>
              <div className="fe-pricing-pro__hero-sub">All-In-One AI Platform Suite</div>
            </div>

            <ul className="fe-pricing-pro__features">
              {FE_PRICING_FEATURES.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>

            <p className="fe-pricing-pro__bonus">🎁 Includes All Bonuses To Help You Get Results Faster
            </p>

            <div className="fe-pricing-pro__price-wrap">
              <p className="fe-pricing-pro__price-heading">Special Launch Price (Limited Time)</p>
              <p className="fe-pricing-pro__regular">
                Regular Price: <span>$97</span> / Month — Today Just $8.99 One-Time

              </p>
              <p className="fe-pricing-pro__current">Get Full Access Today For Just</p>
              <p className="fe-pricing-pro__price">$8.99</p>
              <p className="fe-pricing-pro__no-recurring">(One-Time Payment)</p>
            </div>
            <div className="fe-pricing-pro__cart-btn">
              <a
                className="fe-cart-btn"
                href="https://warriorplus.com/o2/buy/sd90jm/s1t6b1/wvd1gk"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={addtocart} alt="Add to Cart" />
              </a></div>



            <p className="fe-pricing-pro__disclaimer">
              <em>WarriorPlus is used to help manage the sale of products on this site. While WarriorPlus helps facilitate the sale, all payments are made directly to the product vendor and NOT WarriorPlus. Thus, all product questions, support inquiries and/or refund requests must be sent to the vendor. WarriorPlus's role should not be construed as an endorsement, approval or review of these products or any claim, statement or opinion used in the marketing of these products.</em>
            </p>
            <p className="fe-dark-cta__line1">
              No Monthly Fees • No Hidden Costs • Pay Once, Use Forever

            </p>
          </article>
        </div>
      </section>

      <section className="fe-section-guarantee" aria-labelledby="fe-guarantee-heading">
        <div className="fe-guarantee__inner">
          <p className="fe-guarantee__badge">Still Not Sure? Try It Risk-Free
          </p>
          <h2 id="fe-guarantee-heading" className="fe-guarantee__title">
            Try Leadszora Risk-Free With {' '}
            <span className="fe-guarantee__title-accent">7-Day Money-Back Guarantee</span>
          </h2>

          <div className="fe-guarantee__content">
            <div className="fe-guarantee__visual" aria-hidden="true">
              {/* <div className="fe-guarantee__screen fe-guarantee__screen--main">
              </div>
              <div className="fe-guarantee__screen fe-guarantee__screen--left" />
              <div className="fe-guarantee__screen fe-guarantee__screen--right" /> */}
              <img
                className="guarantee__screen fe-guarantee__screen--main"
                src={guarantee1}
                alt="Guarantee 1"
                loading="lazy"
                decoding="async"
                width={900}
                height={520}
              />
            </div>

            <div className="fe-guarantee__copy">
              <p>
                We want you to feel completely confident trying leadszora

              </p>
              <p>
                That’s why you can test the full system — find leads, send outreach, and manage your workflow — completely risk-free

              </p>
              <p>
                If it’s not the right fit for you, simply request a refund within 7 days — no complicated process, no questions asked

              </p>
              <p>
                You get full access from day one, so you can explore everything and see real results

              </p>
              <p className="fe-guarantee__closing">
                No long-term commitment. No hidden fees. Just one simple system you can try today

              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="fe-section-see-you-inside" aria-labelledby="fe-see-you-inside-heading">
        <div className="fe-see-you-inside__inner">
          <div className="fe-see-you-inside__card">
            <div className="fe-see-you-inside__photo-col">
              <img
                className="fe-see-you-inside__photo"
                src={Profile}
                alt="Ashish Kathiriya"
                width={280}
                height={280}
                loading="lazy"
                decoding="async"
              />
              <p className="fe-see-you-inside__name">Ashish Kathiriya</p>
            </div>
            <div className="fe-see-you-inside__copy">
              <h2 id="fe-see-you-inside-heading" className="fe-see-you-inside__headline">
                Get Started In Minutes — No Setup, No Confusion

              </h2>
              <p className="fe-see-you-inside__copy1"> Get instant access to leadszora and start finding, managing, and contacting leads within minutes
              </p>
              <p className="fe-see-you-inside__para">
                ✔ No Monthly Fees — One-time payment, lifetime access

              </p>
              <p className="fe-see-you-inside__para">
                ✔ Beginner-Friendly — Simple system built for daily use

              </p>
              <p className="fe-see-you-inside__para">
                ✔ Risk-Free — Covered by our money-back guarantee

              </p>
              <p>You’re fully protected by our money-back guarantee — so you can try it risk-free.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="fe-section-final-disclaimer" aria-labelledby="fe-final-disclaimer-heading">
        <div className="fe-final-disclaimer__inner">
          <p className="fe-final-disclaimer__badge">Important Information & Compliance
          </p>

          <h2 id="fe-final-disclaimer-heading" className="fe-final-disclaimer__headline">
            leadszora is a business research and lead generation platform designed to help you discover, organize, and manage publicly available business data

          </h2>
          <p className="fe-final-disclaimer__line">
            This platform is intended for lead research and outreach activities and does not guarantee specific results, sales, or income

          </p>
          <p className="fe-final-disclaimer__line fe-final-disclaimer__line--strong">
            All data used within the platform is sourced from publicly available business information

          </p>
          <p className="fe-final-disclaimer__line fe-final-disclaimer__line--strong">
            Users are responsible for how they use the data and must follow applicable laws and regulations (such as GDPR, CAN-SPAM, etc.)

          </p>
        </div>

      </section>
      <footer className="oto2-site-footer">

        <div className="oto2-site-footer__inner">
          <p className="oto2-site-footer__copy">
            © {new Date().getFullYear()} Leadszora. All Rights Reserved.
          </p>
          <nav className="oto2-site-footer__nav" aria-label="Footer">
            <a href="/2.0privacy-policy">Privacy Policy</a>
            <span className="oto2-site-footer__sep" aria-hidden>
              |
            </span>
            <a href="/2.0Terms-of-Service">Terms &amp; Conditions</a>
            <span className="oto2-site-footer__sep" aria-hidden>
              |
            </span>
            <a href="/2.0Earning-Disclaimer">Earning Disclaimer</a>
            <span className="oto2-site-footer__sep" aria-hidden>
              |
            </span>
            <a href="/2.0Contact-Us">Contact Us</a>
          </nav>
        </div>
      </footer>

      {/* {!feCornerPopupDismissed && feCornerPopupVisible ? (
        <div
          className="fe-corner-popup"
          role="status"
          aria-live="polite"
          aria-atomic="true"
          key={feCornerPopupIdx}
        >
          <img
            className="fe-corner-popup__avatar"
            src={feCornerPopup.img}
            alt=""
            width={48}
            height={48}
            decoding="async"
          />
          <div className="fe-corner-popup__body">
            
            <p className="fe-corner-popup__title">
              <strong>{feCornerPopup.name}</strong>
              <span className="fe-corner-popup__from"> from {feCornerPopup.place}</span>
            </p>
            <p className="fe-corner-popup__line">{feCornerPopup.line}</p>
          </div>
        </div>
      ) : null} */}
    </div>
  )
}
